import { render } from "./CatalogAttributeFormGroup.vue?vue&type=template&id=2ce12217"
import script from "./CatalogAttributeFormGroup.vue?vue&type=script&lang=js"
export * from "./CatalogAttributeFormGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__